import styled from "styled-components";
import { BREAKPOINTS } from "../../variables/Breakpoints";
import { setFlex, setPosition } from "../../variables/Position";

export const VideoWrapper = styled.div`
  ${setPosition({ position: "relative" })};
  ${props => props.$margin && "margin: 5rem 0"};
  ${props =>
    props.$scale &&
    `
    ${setPosition({ position: "absolute", bottom: "0", right: "0" })};
    height: 20%;
    width: 35%;
    overflow: hidden;
    will-change: scale;
    @media (max-width: ${BREAKPOINTS.sm}px) {
      width: 50vw;
      height: 50vw;
      margin: 0 auto;
      ${setPosition({ position: "unset" })}};
    }
  `};
`;

export const ControlsContainer = styled.div`
  ${setPosition({ position: "absolute", bottom: "0", left: "0" })};
  margin: 1rem;
  &:not(.show-controls) {
    display: none;
  }
`;

export const VolumeButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  filter: invert(1);
  img {
    background-color: transparent;
    max-height: 35px;
  }
`;

export const VideoContainer = styled.div`
  height: 100%;
  width: 100%;
  max-height: 100vh;
  max-width: 100vw;
  video {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
`;

export const Video = styled.div`
  ${setFlex({})};
  width: auto;
  height: 100%;
  margin: 0 auto;
  ${props => props.$padding && "padding-bottom: 40px"};
`;
